import { useEffect } from "react";

const EPIC_DYNAMIC_IFRAME_HEIGHT_MESSAGE = "requestDynamicIframeHeight";

let hasRequestedDynamicIframeHeight = false;

export function useEpicDynamicIframeHeight() {
  useEffect(() => {
    if (hasRequestedDynamicIframeHeight) {
      return;
    }

    hasRequestedDynamicIframeHeight = true;
    window.parent.postMessage(EPIC_DYNAMIC_IFRAME_HEIGHT_MESSAGE, "*");
  }, []);
}
